import { render, staticRenderFns } from "./editorFormTool.vue?vue&type=template&id=5d4f985f&scoped=true"
import script from "./editorFormTool.vue?vue&type=script&lang=js"
export * from "./editorFormTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f985f",
  null
  
)

export default component.exports